/**
 * 读取字典
 */
import {Atom, useAtomValue} from 'jotai';
import {waitForAll} from 'jotai/utils';
import {DictInstance} from '../common';
import {useMemo} from 'react';

import _ from 'lodash-es';
import {
    AccountTypeAtom,
    ColumnTypeAtom,
    dictStore,
    EnabledStatusAtom,
    IsPageTypeAtom,
    modelStoreWithCode,
    OperateTypeAtom,
    PositionTypeAtom,
    StatusAtom,
    TagTypeAtom,
    TenantOptionsAtom,
    TenantTypeAtom,
} from '../../Stores/commonStore';
import {RoleListAtom} from '../../Stores/userStore';

type KeyType =
    | 'InsuranceStatus'
    | 'RoleList'
    | 'MenuType'
    | 'ServiceVersion' //版本
    | 'RegType' //注册方式 手机 电脑
    | 'RegBy' //注册渠道 系统登记，线上注册
    | 'Status' //状态 启用 停用
    | 'ScenarioType' //方案类型
    | 'ServiceStatus' //服务状态
    | 'ServiceTime' //服务期限
    | 'TenantStatus' //租户状态
    | 'TenantType' //租户类型
    | 'H5ShowType' //H5校友展示类型
    | 'AccountType'
    | 'IconType'
    | 'TagType'
    | 'ColumnType' //大数据，栏目类型
    | 'OperateType' //大数据，页面类型
    | 'IsPageType' //大数据，是否是翻页动作
    | 'PositionType' //大数据，定位类型
    | 'Tenant' //租户
    | 'Switch'; //开关

type StoreType = {
    [key in KeyType]: Atom<DictInstance> | Atom<Promise<DictInstance>>;
};

/**
 * 注意事项, 一定要在模块的首页把所有相关dict都一起引进来进行缓存
 * 避免进入页面时再加载数据
 * @param keys
 */
export function useDictAll<T extends KeyType>(keys: T[]) {
    const stores: StoreType = useMemo(
        () => ({
            InsuranceStatus: dictStore('DIM_COVERAGE_STATUS'),
            IconType: dictStore('DIM_ICON_TYPE'),
            RoleList: RoleListAtom,
            TenantType: TenantTypeAtom,
            Status: StatusAtom,
            AccountType: AccountTypeAtom,
            MenuType: dictStore('DIM_MENU_TYPE'),
            ScenarioType: dictStore('DIM_SCHEME_TYPE'),
            RegType: dictStore('DIM_REGISTRATION_METHOD'),
            RegBy: dictStore(' '),
            TenantStatus: dictStore('DIM_TENANT_STATUS'),
            Switch: dictStore('DIM_SWITCH'),
            ServiceTime: dictStore('DIM_SERVICE_PERIOD'),
            ServiceStatus: dictStore('DIM_SERVICE_STATUS'),
            H5ShowType: dictStore('DIM_H5_SHOW_TYPE'),
            ServiceVersion: modelStoreWithCode({
                code: 'serviceVersion',
                bindValue: 'id',
                bindName: 'name',
                data: {
                    status: '1',
                },
            }),
            TagType: TagTypeAtom,
            ColumnType: ColumnTypeAtom,
            OperateType: OperateTypeAtom,
            IsPageType: IsPageTypeAtom,
            PositionType: PositionTypeAtom,
            EnabledStatus: EnabledStatusAtom,
            Tenant: TenantOptionsAtom,
        }),
        [],
    );

    const allKeys = useMemo(() => Object.keys(stores), [stores]);

    if (_.difference(keys, allKeys).length !== 0)
        throw new Error(`不存在的字典key: ${_.difference(keys, allKeys)}`);

    const dictList = useAtomValue(waitForAll(keys.map(key => stores[key])));

    return useMemo(() => {
        const map: any = {};

        keys.forEach((key, index) => {
            map[key] = dictList[index];
        });

        return map as Record<T, DictInstance>;
    }, [keys, dictList]);
}
